/** Perspectivas da análise de mercado de clientes */
export interface ClienteAnaliseMercadoPerspectiva {
    id: number;
    nome: string;
}

export const perspectivaRAP: ClienteAnaliseMercadoPerspectiva = {id: 1, nome: 'RAP - Receita Anual Pretendida'};
export const perspectivaClassificacao: ClienteAnaliseMercadoPerspectiva = {id: 2, nome: 'Segmentos'};
export const perspectivaProjetada: ClienteAnaliseMercadoPerspectiva = {id: 3, nome: 'Projetada'};
export const perspectivaMeta: ClienteAnaliseMercadoPerspectiva = {id: 4, nome: 'Meta'};

export const perspectivas: ClienteAnaliseMercadoPerspectiva[] = [
    perspectivaRAP,
    perspectivaClassificacao,
    perspectivaProjetada,
    perspectivaMeta
];

/** Obtem a perspectiva da Análise de Mercado */
export function getPerspectiva(perspectiva: number): ClienteAnaliseMercadoPerspectiva {
    if (!perspectiva) {
        return null;
    }

    return perspectivas.find(p => p.id === perspectiva);
}

/** Verifica se a perspectiva informado é RAP */
export function isPerspectivaRAP(perspectiva: number): boolean {
    return perspectiva === perspectivaRAP.id;
}

/** Verifica se a perspectiva informado é Classificacao */
export function isPerspectivaClassificacao(perspectiva: number): boolean {
    return perspectiva === perspectivaClassificacao.id;
}

/** Verifica se a perspectiva informado é Projetada */
export function isPerspectivaProjetada(perspectiva: number): boolean {
    return perspectiva === perspectivaProjetada.id;
}


/** Verifica se a perspectiva informado é Meta */
export function isPerspectivaMeta(perspectiva: number): boolean {
    return perspectiva === perspectivaMeta.id;
}

/** Verifica se a perspectiva informado é Projetada ou Meta */
export function isPerspectivaProjetadaOuMeta(perspectiva: number): boolean {
    return isPerspectivaProjetada(perspectiva) || isPerspectivaMeta(perspectiva);
}
